import React from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { Grid } from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
// import { useTranslation } from "react-i18next";
import { paymentMethodList } from "../../../utils/App";
import { EPaymentMethod } from "../../../utils/enum/PaymentMethod";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        formControl: {
            minWidth: 120,
            maxWidth: 300,
        },
        chips: {
            display: "flex",
            flexWrap: "wrap",
        },
        chip: {
            margin: 2,
        },
        noLabel: {
            marginTop: theme.spacing(3),
        },

        inpuText: {
            marginBottom: 14,
            marginTop: 6
        },
        inputLabel: {
            fontSize: 14,
            fontFamily: "Josefin Sans",
            color: "#000000",
        },
        containerLabel: {
            textAlign: "left",
        },
        selectMulti: {
            width: "100%",
        },
    })
);

// const ITEM_HEIGHT = 48;
// const ITEM_PADDING_TOP = 8;
// const MenuProps = {
//     PaperProps: {
//         style: {
//             maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
//             width: 250,
//         },
//     },
// };


export default function PropertySelect(props: {
    id: string;
    label: string;
    name: string;
    value: string | number | Array<string>;
    handleChange: (e: any) => void;
}) {
    const classes = useStyles();
    const { id, label, name, value, handleChange } = props;
    // const {t} = useTranslation();

    return (
        <>
            <Grid item lg={12} sm={12} xs={12}>
                <label
                    htmlFor={id}
                    className={classes.inputLabel}
                >
                    {label}
                </label>
            </Grid>
            <Grid item lg={12} sm={12} xs={12} className={classes.inpuText}>
                <Select
                    id={id}
                    name={name}
                    fullWidth
                    value={value}
                    onChange={handleChange}
                    variant="outlined"
                >
                     {
                        paymentMethodList.filter(item=>item.value!==EPaymentMethod.Paypal).map(method=><MenuItem
                            key={method.label+method.value}
                            value={method.value}
                        >
                            {method.label}
                        </MenuItem>)
                    }
                </Select>
            </Grid>
        </>
    );
}
